import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import "./AlumniLogin.css";
import "./AlumniPasswordReset.css";

const AlumniPasswordOtp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const inputs = [useRef(null), useRef(null), useRef(null), useRef(null)];
  const [email, setEmail] = useState("");
  const [otpValues, setOtpValues] = useState(["", "", "", ""]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const [resendMessage, setResendMessage] = useState("");

  useEffect(() => {
    if (location.state?.email) {
      setEmail(location.state.email);
    } else {
      navigate("/alumni-forgot-password");
    }
  }, [location.state, navigate]);

  const handleInputChange = (index, e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 1);
    setOtpValues((prevValues) => {
      const nextValues = [...prevValues];
      nextValues[index] = value;
      return nextValues;
    });

    setErrors((prev) => ({ ...prev, otp: "", form: "" }));

    if (value && index < inputs.length - 1) {
      inputs[index + 1].current?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otpValues[index] && index > 0) {
      inputs[index - 1].current?.focus();
    }
  };

  const handleResendOtp = async (e) => {
    e.preventDefault();
    if (!email || resending) return;
    try {
      setResending(true);
      setResendMessage("");
      const response = await axios.post(
        "/backend/alumni/send-otp",
        { email },
        { withCredentials: true }
      );
      if (response.data.success) {
        setResendMessage("New OTP sent successfully!");
        setErrors({});
      } else {
        setErrors((prev) => ({
          ...prev,
          form: response.data.message || "Failed to resend OTP",
        }));
      }
    } catch (err) {
      setErrors((prev) => ({
        ...prev,
        form: err?.response?.data?.message || "Failed to resend OTP",
      }));
    } finally {
      setResending(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const otp = otpValues.join("");
    if (otp.length !== 4) {
      setErrors((prev) => ({ ...prev, otp: "Enter a valid 4-digit OTP" }));
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(
        "/backend/alumni/validate-otp",
        { email, otp },
        { withCredentials: true }
      );

      if (response.data.success) {
        navigate("/alumni-password-create", {
          state: { email },
        });
      } else {
        setErrors((prev) => ({
          ...prev,
          form: response.data.message || "Invalid OTP",
        }));
      }
    } catch (error) {
      const message =
        error?.response?.data?.message || "Failed to validate OTP. Please try again.";
      setErrors((prev) => ({
        ...prev,
        form: message,
      }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="alumni-login-page">
      <div className="alumni-login-card">
        <h1 className="alumni-login-title"> Verify OTP</h1>
        <div className="alumni-login-line"></div>

        <p className="alumni-reset-helper">
          OTP has been sent to <strong>{email}</strong>. Enter the 4-digit code below.
        </p>

        {errors.form && <p className="alumni-page-message error">{errors.form}</p>}

        <form onSubmit={handleSubmit}>
          <div className="alumni-otp-row">
            {inputs.map((input, index) => (
              <input
                ref={input}
                key={index}
                className="alumni-otp-input"
                inputMode="numeric"
                maxLength="1"
                value={otpValues[index]}
                onChange={(e) => handleInputChange(index, e)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                aria-invalid={Boolean(errors.otp)}
              />
            ))}
          </div>
          {errors.otp && <p className="alumni-field-error alumni-otp-error">{errors.otp}</p>}
          {resendMessage && <p className="alumni-page-message success">{resendMessage}</p>}

          <button type="submit" className="alumni-login-btn" disabled={loading}>
            {loading ? "Verifying OTP..." : "Verify OTP"}
          </button>

          <div className="alumni-register-text">
            Didn't receive code?{" "}
            <button
              type="button"
              onClick={handleResendOtp}
              disabled={resending}
              style={{
                background: "none",
                border: "none",
                color: "#0f766e",
                fontWeight: 600,
                cursor: "pointer",
                padding: 0,
                textDecoration: "underline",
              }}
            >
              {resending ? "Resending..." : "Resend OTP"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AlumniPasswordOtp;
